import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import cognitoAuth from "./cognito";
import "./assets/buefy.min.css";
import Vuex from "vuex";
import config from "@/config/index";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import VueCodemirror from "vue-codemirror";
import * as VueGoogleMaps from "vue2-google-maps";

// require styles
import "codemirror/lib/codemirror.css";

import "bulma-timeline/dist/css/bulma-timeline.min.css";

Vue.config.productionTip = false;

let promiseList = [];
for (let i = 0; i < config.Sites.length; i++) {
  promiseList.push(import(`@/sections/${config.Sites[i]}/config/index`));
}

Promise.all(promiseList).then((data) => {
  data.forEach((site) => {
    store.commit("AddSite", site.default);
  });
});

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBKiRjSP9w8HEQxbW0J0sgrZmwKwVJrZCs",
    libraries: "places,visualization",
  },
});

if (process.env.NODE_ENV == "production") {
  Sentry.init({
    Vue,
    dsn: "https://9a2a0cb741734093812338c86b18ff0b@o1167704.ingest.sentry.io/6265259",
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["api.jeak.co.uk"],
      }),
    ],

    tracesSampleRate: process.env.NODE_ENV == "production" ? 1.0 : 0.0,
  });
}

document.title = "Home | Voice Management";
Vue.use(Buefy, {
  defaultIconPack: "fas",
});
Vue.use(Vuex);
Vue.use(VueCodemirror);

new Vue({
  router,
  cognitoAuth,
  store,
  render: (h) => h(App),
}).$mount("#app");
